var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRightBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96936 21.531C6.89952 21.4613 6.8441 21.3786 6.80629 21.2875C6.76848 21.1963 6.74902 21.0987 6.74902 21C6.74902 20.9014 6.76848 20.8037 6.80629 20.7126C6.8441 20.6214 6.89952 20.5387 6.96936 20.469L15.4399 12L6.96936 3.531C6.89963 3.46127 6.84432 3.37849 6.80658 3.28738C6.76884 3.19627 6.74942 3.09862 6.74942 3C6.74942 2.90139 6.76884 2.80374 6.80658 2.71263C6.84432 2.62152 6.89963 2.53873 6.96936 2.469C7.03909 2.39927 7.12188 2.34396 7.21299 2.30622C7.3041 2.26848 7.40175 2.24906 7.50036 2.24906C7.59898 2.24906 7.69663 2.26848 7.78774 2.30622C7.87885 2.34396 7.96163 2.39927 8.03136 2.469L17.0314 11.469C17.1012 11.5387 17.1566 11.6214 17.1944 11.7126C17.2322 11.8037 17.2517 11.9014 17.2517 12C17.2517 12.0987 17.2322 12.1963 17.1944 12.2875C17.1566 12.3786 17.1012 12.4613 17.0314 12.531L8.03136 21.531C7.9617 21.6008 7.87893 21.6563 7.78781 21.6941C7.6967 21.7319 7.59901 21.7513 7.50036 21.7513C7.40171 21.7513 7.30403 21.7319 7.21291 21.6941C7.1218 21.6563 7.03903 21.6008 6.96936 21.531Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightBlack);
export default __webpack_public_path__ + "static/media/icon_arrow_right_black.fd6463b2.svg";
export { ForwardRef as ReactComponent };